<template>
    <div>
        <edit-member-category-modal
            v-model="editMemberCategoryDialog"
            :modelProp="memberCategorySelected"
            :memberProp="member"
            :constants="constant"
            :valuelists="valuelist"
            @successful-member-category-save="$emit('successful-save')"
            @successful-member-category-delete="$emit('successful-delete')"
        ></edit-member-category-modal>

        <div class="tw-flex tw-flex-row tw-gap-4 tw-p-1">
            <div class="tw-flex tw-flex-col tw-w-1/3 tw-gap-4"><!-- left side -->
                <internal-table-section button-text="Add New Category" @button-clicked="addMemberCategory" class="tw-w-full">
                </internal-table-section>

                <internal-table-section section-title="Historical Categories" :has-button="false" class="tw-w-full">
                    <smart-table
                        :items="historicalFunctions"
                        :headers="headers_historical"
                        hide-default-header
                        hide-default-footer
                        :items-per-page="-1"
                        :options="{itemsPerPage:[-1]}"
                    >
                        <template v-slot:item.created_at="{ isMobile, item, header, value, index}">
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <span v-on="on">{{ formatTimestamp(value) }}</span>
                                </template>
                                <span>Creation Date</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:item.updated_at="{ isMobile, item, header, value, index}">
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <span v-on="on">{{ formatTimestamp(value) }}</span>
                                </template>
                                <span>Updated Date</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:item.action="{ isMobile, item, header, value, index}">
                            <v-icon @click="restoreHistory(item)">mdi-restore</v-icon>
                        </template>
                    </smart-table>
                </internal-table-section>
            </div>

            <div class="tw-flex tw-flex tw-w-2/3 tw-flex-wrap tw-justify-between tw-items-start tw-gap-4"><!-- right side -->
                <div v-for="category in currentFunctions" class="tw-rounded-lg tw-shadow tw-p-4" style="width: calc(50% - 0.5rem); border-top: 12px solid #67cea3;">
                    <v-card flat>
                        <v-card-title class="pt-0 px-0">{{ category?.title_function?.name }}</v-card-title>
                        <v-card-subtitle class="px-0">{{ category?.title_function?.department }}</v-card-subtitle>
                        <v-card-text class="px-0">
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <v-chip v-on="on">{{ category?.title_function?.id }}</v-chip>
                                </template>
                                <span>Category ID</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <v-chip v-on="on" v-show="category?.default">{{ findValuelist(valuelist?.CATEGORY_DEFAULTS, category?.default).text }}</v-chip>
                                </template>
                                <span>Default Type</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <v-chip v-on="on">{{ formatTimestamp(category?.created_at) }}</v-chip>
                                </template>
                                <span>Creation Date</span>
                            </v-tooltip>
                        </v-card-text>
                        <v-card-actions class="pb-0 px-0">
                            <v-btn class="main-btn" @click="editMemberCategory(category)">
                                Edit
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import InternalTableSection from "@/Generic/InternalTableSection";
    import EditMemberCategoryModal from "@/Modals/EditMemberCategoryModal"

    export default {
        name: "MembersShowCategories",
        components: {
            SmartTable,
            InternalHeader,
            InternalTableSection,
            EditMemberCategoryModal,
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            }
        },
        data() {
            return {
                member: this.input,
                constant: this.constants,
                valuelist: this.valuelists,
                editMemberCategoryDialog: false,
                memberCategorySelected: {},
            }
        },
        computed: {
            orderedFunctions() {
                return this.member.functions.sort(function (a, b) {
                    return a.title_function?.priority - b.title_function?.priority
                })
            },
            currentFunctions() {
                return this.orderedFunctions.filter(category => !category.is_historical)
            },
            historicalFunctions() {
                return this.orderedFunctions.filter(category => category.is_historical)
            },
            headers_historical() {
                return [
                    {value: 'function_name',    text: 'Name',           align: `start`, sortable: true,   filterable: false, },
                    {value: 'created_at',       text: 'Created',        align: `start`, sortable: true,   filterable: false, },
                    {value: 'updated_at',       text: 'Updated',        align: `start`, sortable: true,   filterable: false, },
                    {value: 'action',           text: '',               align: `start`, sortable: true,   filterable: false, },
                ]
            },
        },
        methods: {
            formatTimestamp(timestamp) {
                return new Date(timestamp).toISOString().split('T')[0]
            },
            editMemberCategory(category) {
                this.memberCategorySelected = category
                this.editMemberCategoryDialog = true
            },
            addMemberCategory() {
                this.memberCategorySelected = null
                this.editMemberCategoryDialog = true
            },
            findValuelist(list, id) {
                if (list && id) {
                    return list.find(obj => obj.value === id)
                } else {
                    return ""
                }
            },
            async restoreHistory(category)
            {
                if (await this.$root.confirm.open(`Restore History`, `You are about to send ${category?.title_function?.name} to the active categories`)) {

                    let method = 'put'
                    let url = route('membercategories.update', category.id)
                    let payload = {
                        'is_historical': false,
                    }

                    axios({
                        method: method,
                        url: url,
                        data: payload,
                        onUploadProgress: (evt) => {
                            this.archiveLoading = !this.archiveLoading
                        },
                        onDownloadProgress: (evt) => {
                            this.archiveLoading = !this.archiveLoading
                        },
                    })
                        .then(response => {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success('Successfully Activated Category')
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.archiveLoading = false
                                this.$emit('successful-save')
                            } else {
                                throw (response.data.error)
                            }
                        })
                        .catch((error) => {
                            // this.$root.snackbar.error(error.response.data.message)
                            this.archiveLoading = false
                        })
                }
            },
        },
        watch: {
            input(newInput, oldInput) {
                this.member = newInput
            },
        }
    }
</script>
